import { Injectable } from '@angular/core';
import { SEU_ENVIRONMENT } from '@seu-environment';
import { SeuEnvApi } from '@seu-types';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  public setEnv(env: SeuEnvApi): void {
    sessionStorage.setItem('env', env);
  }

  public getEnv(): SeuEnvApi | undefined {
    return sessionStorage.getItem('env') as SeuEnvApi | undefined;
  }

  public init(): void {
    // By default the value of env is null and the backend will associate every environment with its default counterpart.
    const selectedEnv = this.getEnv();
    if (!selectedEnv) {
      if (SEU_ENVIRONMENT.env === 'dev') {
        this.setEnv('TEST');
        window.location.reload();
      }
    }
  }
}
